/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Alarms_Form_Isenabled_False1Inputs */



/**
* | output |
* | --- |
* | "This alarm will be recorded but not monitored" |
*
* @param {Alarms_Form_Isenabled_False1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const alarms_form_isenabled_false1 = /** @type {((inputs?: Alarms_Form_Isenabled_False1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Alarms_Form_Isenabled_False1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("This alarm will be recorded but not monitored")
	return /** @type {LocalizedString} */ ("Cette alarme sera enregistrée mais non surveillée")
});
export { alarms_form_isenabled_false1 as "alarms_form_isEnabled_false" }